module.exports = __webpack_public_path__ + "img/stock6.499d8931.png";